import React from 'react';
import { Clock } from 'lucide-react';
export function AuthorByline() {
  return <div className="flex items-center gap-4 py-6 border-b border-gray-200" data-id="element-1">
      {/* Avatar */}
      <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex items-center justify-center text-white font-semibold text-lg flex-shrink-0" data-id="element-2">
        JA
      </div>

      {/* Author info */}
      <div className="flex-1 min-w-0" data-id="element-3">
        <p className="font-semibold text-gray-900" data-id="element-4">Jacqueline Ambrose</p>
        <p className="text-sm text-gray-600" data-id="element-5">
          Writes about consumer health & wellness
        </p>
        <div className="flex items-center gap-3 mt-1 text-xs text-gray-500" data-id="element-6">
          <span data-id="element-7">May 14, 2025</span>
          <span data-id="element-8">·</span>
          <div className="flex items-center gap-1" data-id="element-9">
            <Clock size={12} data-id="element-10" />
            <span data-id="element-11">12 min read</span>
          </div>
        </div>
      </div>
    </div>;
}